import React from "react";

// Lightweight renderer for the subset of Markdown the AI returns
// (## / ### headings, - bullets, **bold**, blank-line paragraphs).
function renderInline(text, keyBase) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return (
        <strong key={`${keyBase}-b-${i}`} className="font-semibold text-slate-900">
          {part.slice(2, -2)}
        </strong>
      );
    }
    return <React.Fragment key={`${keyBase}-t-${i}`}>{part}</React.Fragment>;
  });
}

export function Markdown({ content }) {
  const lines = (content || "").split("\n");
  const blocks = [];
  let list = [];

  const flushList = (key) => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${key}`} className="my-2 space-y-1.5 pl-1">
          {list.map((item, i) => (
            <li key={i} className="flex gap-2 text-slate-600">
              <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary" />
              <span>{renderInline(item, `li-${key}-${i}`)}</span>
            </li>
          ))}
        </ul>
      );
      list = [];
    }
  };

  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (/^#{2,3}\s+/.test(line)) {
      flushList(idx);
      const text = line.replace(/^#{2,3}\s+/, "");
      blocks.push(
        <h4 key={`h-${idx}`} className="font-display mt-4 mb-1 text-base font-bold text-slate-900">
          {renderInline(text, `h-${idx}`)}
        </h4>
      );
    } else if (/^[-*]\s+/.test(line)) {
      list.push(line.replace(/^[-*]\s+/, ""));
    } else if (line.trim() === "") {
      flushList(idx);
    } else {
      flushList(idx);
      blocks.push(
        <p key={`p-${idx}`} className="my-1.5 leading-relaxed text-slate-600">
          {renderInline(line, `p-${idx}`)}
        </p>
      );
    }
  });
  flushList("end");

  return <div className="text-[15px]">{blocks}</div>;
}
